export default __webpack_public_path__ + "static/media/cs_icon_09.12adb631.png";